export interface ISnookerTable {
  id: number;
  uuid: string;
  position: number;
  description: string;
  isDeleted: boolean;
  peekPrice: number;
  offPeekPrice: number;
  peekStart: Date;
  peekEnd: Date;
  hasStarted: boolean;
  startTime: Date;
  receiptData: string;
  advancePayment: number;
  reminderInMinutes: number;
  style: string;
}

export const defaultSnookerTable: ISnookerTable = {
  id: 0,
  uuid: "",
  position: 0,
  description: "",
  isDeleted: false,
  peekPrice: 0,
  offPeekPrice: 0,
  peekStart: new Date(),
  peekEnd: new Date(),
  hasStarted: false,
  startTime: new Date(),
  receiptData: "",
  advancePayment: 0,
  reminderInMinutes: 0,
  style: "",
};
